import Page from '@app/components/layout/page/page';
import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import Text from '@shared/components/content/text';
import { Link, useNavigate } from 'react-router-dom';
import CCFPackagingTable from '../../components/scope-3/packaging/packaging-table';
import { reportSlugs } from '../../slugs';
import { useCategory } from '../../utils';
import EmptyCategoryPage from '../ccf-category-intro-page';

export default function PackagingPage() {
  const navigate = useNavigate();
  const category = useCategory(reportSlugs.packaging);

  return (
    <Page name="Scope 3 - Packaging" page="subpage">
      {category.hasActivityData ? (
        <CCFPackagingTable />
      ) : (
        <EmptyCategoryPage
          categorySlug="packaging"
          description={
            <div className="space-y-4">
              <Text>
                The emissions from the packaging you purchase fall within Scope
                3, Category 1 - Purchased Goods & Services. This category
                represents <b>the majority of your Scope 3 emissions</b>, and is
                therefore the only Scope 3 Category that WRAP requires you to
                report in their sector-specific guidance.
              </Text>
              <Text>
                Your packaging purchases are managed via the{' '}
                <Link
                  to={purchasedGoodsRoutes.PURCHASED_PACKAGING}
                  className="font-medium text-teal-600"
                >
                  Purchased goods
                </Link>{' '}
                area of our platform, where our AI-powered tool will allow you
                to easily import your purchase data from a spreadsheet.
                Emissions from purchases that fall within this reporting year
                will appear here automatically once you have completed the
                import.
              </Text>
            </div>
          }
          primaryActionText="Manage imports"
          primaryActionProps={{
            onClick: () =>
              navigate(
                purchasedGoodsRoutes.PURCHASED_GOODS_IMPORTS_LIST +
                  `?activityType=packaging`
              ),
          }}
        />
      )}
    </Page>
  );
}
